<template>
  <v-theme-provider dark>
    <base-section
      id="difference"
      class="secondary text-center"
      space="56"
    >
      <base-icon class="mb-8">
        mdi-waves
      </base-icon>

      <base-section-heading
        color="transparent"
        title="The MeStream Difference"
      >
        Feeling powerless in the face of Tech Monopolies? MeStream puts you back in control.
      </base-section-heading>

      <div class="py-4" />

      <v-btn
        class="font-weight-bold"
        color="white"
        href="/signup"
        light
        min-width="168"
        x-large
      >
        Sign Up
      </v-btn>
    </base-section>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BigBoom',

    provide: {
      heading: { align: 'center' },
    },
  }
</script>
